import { Popover, Popper } from "@mui/material";
import React from "react";

export default function CorePopOver({
  id,
  open,
  anchorEl,
  handlePopoverClose,
  top,
  left,
  ...restProps
}) {
  return (
    <Popper
      id={id}
      open={anchorEl ? true : false}
      anchorEl={anchorEl}
      onClose={handlePopoverClose}
      elevation={false}
      placement="right"
      disablePortal={false}
      modifiers={[
        {
          name: "flip",
          enabled: true,
          options: {
            altBoundary: true,
            rootBoundary: "document",
            padding: 8,
          },
        },
        {
          name: "preventOverflow",
          enabled: true,
          options: {
            altAxis: true,
            altBoundary: true,
            tether: true,
            rootBoundary: "document",
            padding: 8,
          },
        },
        // {
        //   name: "arrow",
        //   enabled: false,
        //   options: {
        //     element: arrowRef,
        //   },
        // },
      ]}
    >
      {restProps?.children}
    </Popper>
  );
}
